import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppSettings } from '../models/app-settings/app-settings.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  private readonly BACKEND_URL = environment.baseUrl + 'backoffice/settings';
  
  private settingsSubject = new BehaviorSubject<AppSettings | null>(null);
  public settings$ = this.settingsSubject.asObservable();
  
  private _settings: AppSettings | null = null;

  constructor(private http: HttpClient) {}

  /**
   * Charge les paramètres de l'application depuis le backend
   */
  loadSettings(): Observable<AppSettings> {
    return this.http.get<AppSettings>(this.BACKEND_URL).pipe(
      tap(settings => {
        this._settings = settings;
        this.settingsSubject.next(settings);
      })
    );
  }

  /**
   * Initialise les paramètres (pour APP_INITIALIZER)
   */
  initializeSettings(): Promise<AppSettings> {
    return this.loadSettings().toPromise();
  }

  /**
   * Retourne les paramètres actuels
   */
  get settings(): AppSettings | null {
    return this._settings;
  }

  /**
   * Retourne le domaine du store
   */
  getStoreDomain(): string {
    return this._settings?.store?.domain || '';
  }

  /**
   * Retourne les langues disponibles
   */
  getAvailableLanguages(): any[] {
    return this._settings?.language?.languages || [];
  }

  /**
   * Retourne la langue par défaut
   */
  getDefaultLanguage(): any {
    return this._settings?.language?.default_language || null;
  }

  /**
   * Génère l'URL complète pour un nouveau shop
   */
  generateShopUrl(shopName: string): string {
    const domain = this.getStoreDomain();
    return domain ? `${shopName}.${domain}` : '';
  }
}
